<script lang="ts">
import Modal from './Modal.vue'
import Loading from './Loading.vue'
import { ref, PropType, defineComponent, reactive } from 'vue'
import { User } from '../../../libs/models'
import { useApi } from '../libs/api'
import { l } from '../libs/localization'
export default defineComponent({
  components: { Modal, Loading },
  emits: ['close'],
  props: {
    user: { type: Object as PropType<User | { id: number, name: string }>, required: true }
  },
  setup (props) {
    const api = useApi()
    const model = reactive({
      type: '',
      message: ''
    })
    const reporting = ref(false)
    const sent = ref(false)
    const violationReport = () => {
      if (reporting.value) return
      if (!model.message || !model.type) return
      reporting.value = true
      const payload = { message: model.message, type: model.type }
      return api.post(`/users/${props.user.id}/report`, payload).then(() => {
        sent.value = true
      }).catch(() => {
        alert(l('違反報告に失敗しました'))
      }).finally(() => {
        reporting.value = false
      })
    }
    return {
      model,
      reporting,
      sent,
      violationReport
    }
  }
})
</script>

<template>
  <Modal @close="$emit('close')">
    <div class="ModalContent">
      <template v-if="sent">
        <div class="ModalTitle" >{{ l('{name}さんの違反を報告', { name: user.name }) }}</div>
        <p>{{ l('送信が完了しました') }}</p>
        <button class="cancel" @click.prevent="$emit('close')">{{ l('閉じる') }}</button>
      </template>
      <template v-else>
        <div class="ModalTitle" >{{ l('{name}さんの違反を報告', { name: user.name }) }}</div>
        <form @submit.prevent="violationReport">
          <select v-model="model.type">
            <option value="">{{ l('選択してください') }}</option>
            <option value="manner">{{ l('発言や利用マナーに少し問題がある') }}</option>
            <option value="violation">{{ l('暴言等の明らかな違反行為') }}</option>
          </select>
          <textarea cols="30" rows="5" :placeholder="l('違反内容を入力してください')" maxlength="255" v-model="model.message"></textarea>
          <div class="Alert">{{ l('※ 虚偽の違反報告には厳格な措置が講じられます') }}</div>
          <loading v-if="reporting" class="loading" />
          <template v-else>
            <button :class="{ disabled: !model.message || !model.type }">{{ l('違反報告を送信') }}</button>
            <button class="cancel" @click.prevent="$emit('close')">{{ l('キャンセル') }}</button>
          </template>
        </form>
      </template>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.ModalContent {
  line-height: 1.5;
}
.Alert {
  margin-top: 10px;
  font-size: 12px;
  color: var(--red);
}
form,
textarea,
select,
button {
  margin-top: 10px;
  width: 100%;
}
</style>
